<!-- Evaluation.vue -->
<template>
	<div class="ui-evaluation">
		<div class="ui-evaluation-header">
			<div class="flex-header">
				<div
					v-for="(item, index) in staticData"
					v-bind:key="item.id"
					v-bind:class="{ active: currentTag == item.value }"
					v-on:click="changeTab(item.value, item.grade)"
				>
					{{ item.name }}
				</div>
			</div>
		</div>
		<div
			class="ui-evaluation-body"
			v-infinite-scroll="loadMore"
			infinite-scroll-disabled="loading"
			infinite-scroll-distance="10"
		>
			<div
				class="list"
				v-for="(item, index) in reviewList"
				v-if="reviewList.length > 0"
			>
				<div class="item">
					<span>
						{{ item.geval_isanonymous? $t('goods_detail.review.anonymous') : item.geval_frommembername }}
						<span
							v-bind:class="{
								'good-review': item.geval_scores > 3,
								'medium-review': item.geval_scores > 1,
								'bad-review': item.geval_scores == 1
							}"
							>{{ getGrade(item.geval_scores) }}</span
						>
					</span>

					<span>{{ getTime(item.geval_addtime) }}</span>
				</div>
				<p v-if="item.geval_content">{{ item.geval_content }}</p>
				<p v-if="!item.geval_content">{{ $t('goods_detail.review.no_content') }}</p>
				<p class="explain" v-if="item.geval_explain">{{ $t('goods_detail.review.store_reply') }}：{{ item.geval_explain }}</p>
				<div class="geval-image-list" v-if="item.geval_image && item.geval_image.length">
					<div class="geval-image-item" v-for="(image,i) in item.geval_image" :key="i">
						<div class="image-wrapper"><img class="image" :src="image" @click="openImage(image)" /></div>
					</div>
				</div>
			</div>

			<div class="list-empty" v-if="reviewList.length <= 0">
				<div class="iconfont empty-icon">&#xe63e;</div>
				<p>{{ $t('goods_detail.alert.no_review') }}</p>
			</div>
		</div>
		<mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
			<img :src="showimage" :style="getBannerStyle" @click="isshow=false">
		</mt-popup>
	</div>
</template>

<script>
import { evaluation } from '../static'
import { getReviewList } from '../../../../api/homegoodsdetail'
export default {
  data () {
    return {
		showimage: '',
		isshow: false,
      staticData: evaluation,
      id: this.$store.state.goodsdetail.currentProductId
        ? this.$store.state.goodsdetail.currentProductId
        : '',
      currentTag: 'total',
      grade: 0,
      subTotal: {},
      reviewList: [],
      page: 0,
      loading: false,
      total: 1
    }
  },
  created () {
  },
	computed: {
		getBannerStyle: function () {
			const { width, height } = window.screen
			let itemWidth = width
			let itemHeight = height
			return {
				maxWidth: itemWidth + 'px',
				maxHeight: itemHeight + 'px'
			}
		}
	},
  methods: {
	  openImage (src) {
		  this.showimage = src
		  this.isshow = true
	  },
    loadMore () {
      this.loading = true
      this.page = ++this.page
      if (this.page <= this.total) {
        this.loading = false
        this.getReviewList(true)
      }
    },
    getReviewList (ispush) {
      getReviewList(this.id, this.grade, this.page).then(res => {
        if (res) {
          if (ispush) {
            this.reviewList = this.reviewList.concat(res.result.goods_eval_list)
          } else {
            this.reviewList = res.result.goods_eval_list
          }
          if (res.hasmore) {
            this.loading = false
          } else {
            this.loading = true
          }
          this.total = res.page_total
        }
      })
    },
    changeTab (value, grade) {
      this.currentTag = value
      this.grade = grade
      this.getReviewList(false)
    },
    getGrade (grade) {
      if (grade == 1) {
        return this.$t('goods_detail.evaluation.bad')
      } else if (grade > 3) {
        return this.$t('goods_detail.evaluation.good')
      } else {
        return this.$t('goods_detail.evaluation.medium')
      }
    },
    getTime (timestamps) {
      let date = new Date(timestamps * 1000)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + '-' + month + '-' + day
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-evaluation {
	.ui-evaluation-header {
		background: #ffffff;
		.flex-header {
			width: auto;
			display: flex;
			display: -webkit-flex;
			display: -moz-flex;
			flex-basis: 100%;
			justify-content: space-around;
			align-content: center;
			align-items: center;
			height: 2.2rem;
			margin-top: 32px;
			div {
				color: #999;
				font-size: 0.7rem;
				height: 1.2rem;
				border: 1px solid #999;
				padding: 0 0.45rem;
				line-height: 1.2rem;
				text-align: center;
				border-radius: .4rem;
				&.active {
					color: #FB2630;
					border: 0.5px solid #FB2630;
				}
			}
		}
	}
	.ui-evaluation-body {
		padding: 0 0.75rem;
		background: rgba(255, 255, 255, 1);
		.list {
			padding: 0.75rem 0;
			border-bottom: 1px solid rgba(232, 234, 237, 1);
			color: #4e545d;
			font-size: 0.7rem;
			.item {
				overflow: hidden;
				padding-bottom: 0.75rem;
				display: flex;
				justify-content: space-between;
				align-content: center;
				align-items: center;
				span {
					&:first-child {
						display: flex;
						justify-content: space-around;
						align-content: center;
						align-items: center;
						span {
							margin-left: 0.75rem;
							color: #ffffff;
							font-size: 0.6rem;
						}
					}
					&:last-child {
						color: #999999;
						font-size: 0.6rem;
					}
					&.good-review {
						background: #fc2e39;
						width: 1.8rem;
						height: 0.8rem;
						text-align: center;
						background-size: cover;
						line-height: 0.8rem;
						border-radius: 0.4rem;
					}
					&.medium-review {
						background: #fa800a;
						width: 1.8rem;
						height: 0.8rem;
						text-align: center;
						background-size: cover;
						line-height: 0.8rem;
						border-radius: 0.4rem;
					}
					&.bad-review {
						background: #c3c3c3;
						width: 1.8rem;
						height: 0.8rem;
						text-align: center;
						background-size: cover;
						line-height: 0.8rem;
						border-radius: 0.4rem;
					}
				}
			}
			p {
				padding: 0;
				margin: 0;
				flex-basis: 100%;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}
		}
		.explain{color:orange}
		.list-empty {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			text-align: center;
			.empty-icon{font-size:3rem;padding:1rem 0;color:#999}
			img {
				width: 2.75rem;
			}
			p {
				color: #999999;
				font-size: 0.8rem;
				padding: 0;
				margin: 0;
				font-weight: normal;
			}
		}
	}
	.geval-image-list{overflow: hidden;margin-top:1rem;
		.geval-image-item{width:33.33%;height:0;padding-bottom: 33.33%;float: left;position: relative;
			.image-wrapper{position: absolute;left:0;right:0.1rem;top:0;bottom:0.1rem;
				.image{width:100%;height: 100%;}
			}
		}
	}
}
</style>
